import * as React from 'react';
import cn from 'classnames';
import { Enum, responsiveClasses, useSpacingProps } from '../../../library';
import { columnClasses } from './column';
export var ColumnJustifyType = Enum({
  START: 'start',
  END: 'end',
  CENTER: 'center',
  JUSTIFY: 'justify',
  SPACE: 'space'
});
export var Columns = function Columns(props) {
  var align = props.align,
    children = props.children,
    collapse = props.collapse,
    justify = props.justify,
    span = props.span,
    split = props.split,
    stack = props.stack,
    style = props.style;
  var _useSpacingProps = useSpacingProps(props),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var className = cn(columnClasses.GROUP, {
    '-collapse': collapse
  }, stack ? responsiveClasses('-stack', stack) : null, split ? responsiveClasses('-split-%s', split) : null, span ? responsiveClasses('-span-%s', span) : null, align ? responsiveClasses("-%s", align) : null, justify ? responsiveClasses('-%s', justify) : null, marginClasses, paddingClasses, props.className);
  return React.createElement("div", {
    className: className,
    style: style,
    children: children
  });
};
Columns.displayName = 'Columns';
Columns.defaultProps = {
  collapse: false
};